<template>
  <div class="c-idea-list">
    <header class="c-idea-list__header">
      <span>{{ideas.length}} Ideas</span>
      <!-- Sort by -->
    </header>

    <idea-item :key="ideas.indexOf(idea)" v-for="idea in ideas" :idea="idea"></idea-item>
  </div>
</template>

<script>
import IdeaItem from '@/components/IdeaItem';

export default {
  name: 'idea-list',

  props: ['ideas'],

  mounted() {},

  components: {
    IdeaItem,
  },
};
</script>

<style lang="scss">
.c-idea-list {
  margin-top: 1em;
  max-width: 800px;

  &__header {
    margin-bottom: 1em;
  }
}
</style>

